const UserProfile = ()=>{
    return(
        <>
            <h1>User Profile Content</h1>
        </>
    )
}

export default UserProfile;